import { canAccessResource } from '../../../authorization/canAccessResource';
import { globalpermissions } from '../../../Services/Permission.js';

const BUSINESS_SERVICE_MAPPING_PERMISSION =
  globalpermissions?.leadDashboard?.mapBusinessServices;

/**
 * Mapping management requires an explicit feature grant and scoped business
 * service edit access in AuthZ v2. Legacy profiles use the dedicated permission.
 */
export function canManageWorkspaceMappings(authz, {
  workspaceId,
  accountId,
  userInfo,
  legacyUserHasPermission,
} = {}) {
  if (!workspaceId) return false;
  if (authz?.isFullAccess) return true;

  if (!authz?.isAuthzV2Enabled) {
    if (typeof legacyUserHasPermission === 'function') {
      return legacyUserHasPermission([
        BUSINESS_SERVICE_MAPPING_PERMISSION,
      ]);
    }

    const legacyPermissions = userInfo?.profile?.permissions || {};
    return Boolean(legacyPermissions[BUSINESS_SERVICE_MAPPING_PERMISSION]);
  }

  if (!authz.grants?.features?.[BUSINESS_SERVICE_MAPPING_PERMISSION]) {
    return false;
  }

  return canAccessResource(authz, {
    type: 'campaign',
    id: workspaceId,
    action: 'edit',
    accountId,
  });
}
